module.exports = ".pause-overlay{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0,0,0,0.5);\n    color: white;\n}\n.pause-overlay .icon-Touch{\n    font-size: 200px;\n}\n.pause-overlay img.h-80{\n    margin-top: 0;\n    height: 80px;\n}\n.pause-overlay img.h-50{\n    margin-top: 15px;\n    height: 50px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pause-overlay/pause-overlay.component.css
// module id = ./src/app/pause-overlay/pause-overlay.component.css
// module chunks = main